import React from 'react';
import { useLocation } from 'react-router-dom';
import NotFound from 'components/atoms/notFound';
import { userHasAccess } from 'utils/accessManager/index';
import useUser from 'utils/useUser';
import { isPatient } from 'utils/userTypeHelper';

import type { IRoute } from '../types';

export const AccessRouteComponent: React.FC<IRoute> = ({
  component: Component,
  path,
}) => {
  const location = useLocation();
  const user = useUser();
  const paths = isPatient(user.userType) ? location.pathname : path;
  const hasAccess = userHasAccess(user, paths);

  if (!hasAccess) {
    return <NotFound />;
  }

  return <Component />;
};
